export default __webpack_public_path__ + "static/media/bm-6.da6d1e10.png";